import { createFileRoute, redirect } from '@tanstack/react-router';

// Rota legacy removida em commit 041451f8. Stub redirect mantem routeTree.gen.ts valido
// ate o proximo `vite dev` regenerar. Bookmarks antigos vao pro dashboard.
export const Route = createFileRoute('/_admin/destaques')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard', replace: true });
  },
});
